interface QuickTaskIconProps {
  size?: number;
  className?: string;
}

export function QuickTaskIcon({ size = 14, className }: QuickTaskIconProps) {
  return (
    <svg
      width={size * 1.25}
      height={size}
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M6.5 8H11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M1.5 12H11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M6.5 16H11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />

      <g
        transform="translate(15, 4.2) scale(0.65)"
        stroke="currentColor"
        strokeWidth="3.077"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344" />
        <path d="m9 11 3 3L22 4" />
      </g>
    </svg>
  );
}
